import { useState } from "react";
import { MessageCircleQuestion } from "lucide-react";
import { CenteredCard, primaryButton, textButton } from "./ui";

/**
 * Nothing ready-made fits, but the dashboard could put something together from its pieces with one more answer.
 * Its assistant wrote `question`; the answer is added to the visitor's details and the queue is built again.
 */
export default function DetailsStep({ question, onSubmit, onSkip }: {
  question: string;
  onSubmit: (answer: string) => void;
  onSkip: () => void;
}) {
  const [draft, setDraft] = useState("");
  const answer = draft.trim();
  return (
    <CenteredCard id="details-title" icon={<MessageCircleQuestion className="h-7 w-7" />} title="One more question"
                  actions={<>
                    <button type="button" onClick={() => onSubmit(answer)} disabled={!answer} className={primaryButton}>
                      Put it together
                    </button>
                    <button type="button" onClick={onSkip} className={textButton}>Skip and talk to us instead</button>
                  </>}>
      <p>Nothing ready-made fits yet, but we can put something together for you with a little more detail.</p>
      <label htmlFor="details-answer" className="w-full text-left font-semibold text-text-primary">{question}</label>
      <textarea id="details-answer" value={draft} maxLength={700} rows={4} onChange={(e) => setDraft(e.target.value)}
                className="w-full rounded-xl border border-borderSubtle bg-white px-4 py-3 text-base text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50" />
    </CenteredCard>
  );
}
